import Swiper from 'swiper';
import { Navigation, Pagination, Virtual, A11y } from 'swiper/modules';
import 'swiper/css';

document.addEventListener("DOMContentLoaded", function () {
	// Check if the screen is desktop size
	const isDesktop = window.innerWidth > 768;

	// Set initial slide dynamically based on screen size
	const initialSlideValue = isDesktop ? 1 : 0;

	// Default Swiper configuration
	const defaultOptions = {
		modules: [Navigation, Pagination, Virtual, A11y],
		direction: "horizontal",
		loop: false,
		centeredSlides: isDesktop, // Enable centered slides only on desktop
		slidesPerView: 1.1,
		spaceBetween: 16,
		grabCursor: false,
		initialSlide: initialSlideValue, // Start from center on desktop, from first slide on mobile
		watchSlidesProgress: true,
		breakpoints: {
			768: {
				slidesPerView: 'auto'
			},
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
			renderBullet: function (index, className) {
				return `
				  <span class="${className}">
					<span class="bullet-dot" aria-hidden="true"></span>
					<span class="hit-area" aria-hidden="true"></span>
				  </span>
				`;
			},
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		a11y: {
			prevSlideMessage: 'Forrige slide',
			nextSlideMessage: 'Næste slide',
		},
		on: {
			init: function () {
				const controls = document.querySelector('.swiper-controls');

				if (this.slides.length <= this.params.slidesPerView || this.isLocked) {
					controls.style.display = 'none';
				} else {
					controls.style.display = 'flex';
				}
			},
			afterInit: function () {
				setTimeout(() => {
					this.update();
				}, 100);
			}
		}
	};

	//Initialize all Swiper instances
	function initSwipers() {
		document.querySelectorAll('.swiper-container').forEach((container) => {
			const swiperEl = container.querySelector('.swiper');
			const prevButton = container.querySelector('.swiper-button-prev');
			const nextButton = container.querySelector('.swiper-button-next');
			const pagination = container.querySelector('.swiper-pagination');

			if (!swiperEl) return;

			const swiper = new Swiper(swiperEl, {
				...defaultOptions,
				loop: false,
				navigation: {
					nextEl: nextButton,
					prevEl: prevButton,
				},
				pagination: {
					el: pagination,
				}
			});
		});
	}

	// Dynamic Swiper(enabled only on mobile)
	function toggleSwiper() {
		const containers = document.querySelectorAll(".mobile-swiper");

		containers.forEach((container) => {
			const stepsContainer = container.querySelector(".steps__list");
			const stepCount = stepsContainer ? stepsContainer.children.length : 0;

			const shouldEnableSwiper = window.innerWidth <= 1200 || stepCount > 3;

			if (shouldEnableSwiper) {
				if (!container.swiper) {
					new Swiper(container, {
						slidesPerView: 1.05,
						breakpoints: {
							768: {
								slidesPerView: 'auto'
							},
						},
						spaceBetween: 8,
						grabCursor: true,
						freeMode: true,
					});
				}
			} else {
				if (container.swiper) {
					container.swiper.destroy(true, true);
				}
			}
		});
	}

	// Quotes
	function initQuoteSwiper() {
		const quoteSlider = document.querySelector(".quote-carousel");
		const slides = document.querySelectorAll('.swiper-slide');
		const enableLoop = slides.length >= 3;


		if (quoteSlider) {
			new Swiper(".quote-carousel", {
				...defaultOptions,
				slidesPerView: 1,
				loop: enableLoop,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
			});
		}
	}

	// Values
	let valuesSwiperInstance = null;

	function initValuesSwiper() {
		const container = document.querySelector(".values-swiper");
		if (!container) return;

		const slides = container.querySelectorAll(".swiper-slide");
		const isMobile = window.innerWidth < 993;

		if (isMobile && slides.length >= 4) {
			if (!valuesSwiperInstance) {
				valuesSwiperInstance = new Swiper(container, {
					slidesPerView: 1.2,
					breakpoints: {
						768: {
							slidesPerView: 'auto'
						},
					},
					spaceBetween: 16,
				});
			}
		} else {
			if (valuesSwiperInstance) {
				valuesSwiperInstance.destroy(true, true);
				valuesSwiperInstance = null;
			}
		}
	}

	function initCarouselSwiper() {
		document.querySelectorAll('.swiper-carousel').forEach((container) => {
			const swiperEl = container.querySelector('.swiper');
			const prevButton = container.querySelector('.swiper-button-prev');
			const nextButton = container.querySelector('.swiper-button-next');
			const pagination = container.querySelector('.swiper-pagination');

			if (!swiperEl) return;

			const swiper = new Swiper(swiperEl, {
				...defaultOptions,
				navigation: {
					nextEl: nextButton,
					prevEl: prevButton,
				},
				pagination: {
					el: pagination,
					clickable: true,
					renderBullet: function (index, className) {
						return `
						<span class="${className}">
						  <span class="bullet-dot" aria-hidden="true"></span>
						  <span class="hit-area" aria-hidden="true"></span>
						</span>
					  `;
					},
				},
			});
		});
	}

	function initCarouselFrontpage() {
		document.querySelectorAll('.swiper-carousel-frontpage').forEach((container) => {
			const swiperEl = container.querySelector('.swiper');
			const prevButton = container.querySelector('.swiper-button-prev');
			const nextButton = container.querySelector('.swiper-button-next');
			const pagination = container.querySelector('.swiper-pagination');

			if (!swiperEl) return;

			const swiper = new Swiper(swiperEl, {
				...defaultOptions,
				spaceBetween: 8,
				loop: false,
				slidesPerView: 1.05,
				centeredSlides: false,
				initialSlide: false,
				breakpoints: {
					1200: {
						slidesPerView: 'auto',
						slidesOffsetAfter: 150
					},
					1920: {
						slidesPerView: 'auto',
						slidesOffsetAfter: 600
					}
				},
				navigation: {
					nextEl: nextButton,
					prevEl: prevButton,
				},
				pagination: {
					el: pagination,
					clickable: true,
					renderBullet: function (index, className) {
						return `
						  <span class="${className}">
							<span class="bullet-dot" aria-hidden="true"></span>
							<span class="hit-area" aria-hidden="true"></span>
						  </span>
						`;
					},
				}
			});
		});
	}

	// Initial check and event listener for resizing
	initSwipers();
	initCarouselSwiper();
	initCarouselFrontpage();
	toggleSwiper();
	initQuoteSwiper();
	initValuesSwiper();

	window.addEventListener("resize", () => {
		toggleSwiper();
		initValuesSwiper();
	});
});